import { defineMessages } from "react-intl";

const baseId = "t.components.modals.genericOTPModal.";

export default defineMessages({
  title: {
    id: baseId + "title",
    defaultMessage: "UNKNOWN ERROR",
  },

  simpleErrorMessage: {
    id: baseId + "simpleErrorMessage",
    defaultMessage: "An error has occurred, please go to home",
  },

  closeBtn: {
    id: baseId + "closeBtn",
    defaultMessage: "Close",
  },
  confirmBtn: {
    id: baseId + "confirmBtn",
    defaultMessage: "Confirm",
  },
});
